// Hide cart icon when loading__spinner is visible
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product-card__add-to-cart').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var spinner = btn.querySelector('.loading__spinner');
      var cartIcon = btn.querySelector('.cart-icon-wrapper');
      if (spinner && cartIcon) {
        spinner.classList.remove('hidden');
        cartIcon.style.display = 'none';
        setTimeout(function () {
          spinner.classList.add('hidden');
          cartIcon.style.display = '';
        }, 1500); // fallback: auto-hide after 1.5s
      }
    });
  });

  // adjust form app style
  const injectStyle = () => {
    const host = document.querySelector('#app-embed');
    if (!host || !host.shadowRoot) return;

    const shadow = host.shadowRoot;

    if (shadow.querySelector('#custom-style')) return;

    const style = document.createElement('style');
    style.id = 'custom-style';
    style.textContent = `
    #app-embed h2._textHeading_2aowh_35 {
      font-size: clamp(25.5px, calc(25.5px + (100vw - 320px) * 0.023297491), 32px);
      color: var(--gray-900);
      font-weight: var(--font-weight-bold);
      margin-bottom: 36px;
    }

    #app-embed ._textBody_2aowh_10, span._textBody_2aowh_10, p._textBody_2aowh_10 {
      color: var(--gray-900);
    }

    #app-embed button._formSubmitButton_cit2d_96 {
      padding: 14px 27px;
      border-radius: 999px;
      font-size: 16px;
      font-weight: 700;
      color: #363C45;
      background: #ADDEDF;
    }
    
    #app-embed ._inline_1q1d2_47 ._formContainer_1q1d2_30 {
      max-width: 600px;
    }

    @media (min-width: 600px) {
      #app-embed h2._textHeading_2aowh_35 {
        font-size: clamp(32px, calc(32px + (100vw - 600px) * 0.0189125296), 40px);
      }
    }

    @media (min-width: 1024px) {
      #app-embed h2._textHeading_2aowh_35 {
        font-size: clamp(40px, calc(40px + (100vw - 1024px) * 0.0120192308), 45px);
      }

      #app-embed ._gridItem_1q1d2_172._gridItemContent_1q1d2_257 {
        padding-top: 80px;
        padding-bottom: 80px;
      }
    }
  `;

    shadow.appendChild(style);
  };

  const observer = new MutationObserver(injectStyle);
  observer.observe(document.body, { childList: true, subtree: true });

  injectStyle();
});
// Custom Swiper
(function () {
  const sectionCleanupMap = new WeakMap()

  function registerSectionCleanup(section, cleanupFn) {
    if (!section || typeof cleanupFn !== 'function') return
    const cleanups = sectionCleanupMap.get(section) || []
    cleanups.push(cleanupFn)
    sectionCleanupMap.set(section, cleanups)
  }

  function runSectionCleanup(section) {
    const cleanups = sectionCleanupMap.get(section)
    if (!cleanups || !cleanups.length) return

    cleanups.forEach((cleanup) => {
      try {
        cleanup()
      } catch (error) {
        console.warn('Cleanup error in custom section', error)
      }
    })

    sectionCleanupMap.delete(section)
  }

  function forEachInScope(root, selector, callback) {
    if (!root || typeof callback !== 'function') return
    let index = 0
    if (root.matches && root.matches(selector)) {
      callback(root, index++)
    }
    root.querySelectorAll(selector).forEach((el) => callback(el, index++))
  }

  const PLAY_ICON = `
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M19 10.2679C20.3333 11.0377 20.3333 12.9623 19 13.7321L10 18.9282C8.66667 19.698 7 18.7358 7 17.1962L7 6.80385C7 5.26425 8.66667 4.302 10 5.0718L19 10.2679Z" fill="#363C45"/>
    </svg>
  `
  const PAUSE_ICON = `
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M8 19C9.1 19 10 18.1 10 17V7C10 5.9 9.1 5 8 5C6.9 5 6 5.9 6 7V17C6 18.1 6.9 19 8 19ZM14 7V17C14 18.1 14.9 19 16 19C17.1 19 18 18.1 18 17V7C18 5.9 17.1 5 16 5C14.9 5 14 5.9 14 7Z" fill="#363C45"/>
    </svg>
  `

  function createCustomSwiper(el, config = {}) {
    if (!el) return null
    if (el.swiper) return el.swiper
    return new Swiper(el, config)
  }

  // 初始化Swiper
  function initSwiperSlideshow(root = document) {
    root.querySelectorAll('.custom-swiper').forEach((el) => {
      // console.log('el', el)
      if (el.swiper) return
      const isAutoPlay = el.dataset.autoplay === 'true'
      const autoplayDelay = Number(el.dataset.speed) || 5000
      const loop = el.dataset.loop === 'true'
      const spaceBetween = Number(el.dataset.spacebetween)
      const isSingleSlide = el.dataset.issingleslide === 'true'
      const centeredSlides = el.dataset.centeredslides === 'true'
      const autoHeight = el.dataset.autoheight === 'true'
      const effect = el.dataset.effect === 'fade' ? 'fade' : 'slide'

      const swiperConfig = {
        spaceBetween: spaceBetween,
        autoHeight: autoHeight,
        loop: loop,
        effect: effect,
        pagination: {
          el: el.querySelector('.swiper-pagination'),
          clickable: true,
        },
        navigation: {
          nextEl: el.querySelector('.swiper-button-next'),
          prevEl: el.querySelector('.swiper-button-prev'),
        },
        centeredSlides: centeredSlides,
      }

      if (isAutoPlay) {
        swiperConfig.autoplay = {
          delay: autoplayDelay,
          disableOnInteraction: false,
        }
        // console.log('--autoplay-speed:', autoplayDelay)
        el.style.setProperty('--autoplay-speed', `${autoplayDelay}ms`)
      }

      let breakpoints

      try {
        breakpoints = el.dataset.breakpoints
          ? JSON.parse(el.dataset.breakpoints)
          : undefined
        swiperConfig.breakpoints = breakpoints
      } catch (e) {
        console.warn('Invalid breakpoints JSON', e)
      }

      if (el.classList.contains('text-col-imgs-swiper')) {
        const slidesCount = el.querySelectorAll('.swiper-slide').length
        const breakpointSlides = breakpoints
          ? Object.values(breakpoints)
            .map((bp) => Number(bp?.slidesPerView) || 1)
            .filter((v) => Number.isFinite(v))
          : []
        const maxSlidesPerView = Math.max(1, ...breakpointSlides)
        // console.log('slidesCount:', slidesCount, 'maxSlidesPerView:', maxSlidesPerView)
        swiperConfig.watchOverflow = true
        swiperConfig.centeredSlides = false

        // if (slidesCount <= maxSlidesPerView) {
        //   swiperConfig.loop = false
        // }
      }

      const swiper = createCustomSwiper(el, swiperConfig)
      const controlBtn = el.querySelector('.control')

      el.addEventListener('click', (e) => {
        if (el.classList.contains('social-feeds-main-swiper')) return
        const slideMedia = e.target.closest('.slide-media')
        if (!slideMedia || !el.contains(slideMedia)) return
        toggleAutoplay(el, swiper)
      })

      if (controlBtn) {
        controlBtn.addEventListener('click', (e) => {
          e.stopPropagation()
          toggleAutoplay(el, swiper)
        })
      }

      swiper.on('slideChange', () => {
        swiper.el.classList.remove('is-paused')
        if (controlBtn) controlBtn.innerHTML = PAUSE_ICON
      })

      swiper.on('slideChangeTransitionStart', () => {
        if (el.classList.contains('is-paused')) {
          el.classList.remove('is-paused')
          swiper.autoplay?.start()
        }
      })

      // Debug用，顯示每個slide的自定義播放時間
      // swiper.slides.forEach((slide, index) => {
      //   console.log(
      //     `Slide ${index}:`,
      //     slide.getAttribute('data-swiper-autoplay')
      //   )
      // })
      // console.log('swiperConfig:', swiperConfig)
    })
  }

  function initSwiperAutoplayProgressSync(root = document) {
    root.querySelectorAll('.custom-swiper.auto-play').forEach((el) => {
      if (!el.swiper || el.dataset.autoplayProgressSyncInit === 'true') return

      const swiper = el.swiper
      const getActiveSlideDelay = () => {
        const activeSlide = swiper.slides?.[swiper.activeIndex]
        const slideDelay = Number(activeSlide?.dataset.swiperAutoplay)
        const wrapperDelay = Number(el.dataset.speed)

        if (Number.isFinite(slideDelay) && slideDelay > 0) return slideDelay
        if (Number.isFinite(wrapperDelay) && wrapperDelay > 0) return wrapperDelay
        return 5000
      }

      const syncProgressDuration = () => {
        el.style.setProperty('--autoplay-speed', `${getActiveSlideDelay()}ms`)
      }

      syncProgressDuration()
      swiper.on('slideChange', syncProgressDuration)
      swiper.on('autoplayStart', syncProgressDuration)

      el.dataset.autoplayProgressSyncInit = 'true'
    })
  }

  function initProductComparisonCards(root = document) {
    root.querySelectorAll('[data-product-card-container]').forEach((container) => {
      if (container.dataset.variantInit === 'true') return
      container.dataset.variantInit = 'true'

      const variantImages = container.querySelectorAll('[data-variant-image]')
      const variantSwatches = container.querySelectorAll('[data-variant-swatch]')

      if (!variantImages.length || !variantSwatches.length) return

      const setActiveVariant = (variantId) => {
        variantImages.forEach((img) => {
          const isActive = img.dataset.variantId === variantId
          img.classList.toggle('is-hidden', !isActive)
          img.setAttribute('aria-hidden', String(!isActive))
        })

        variantSwatches.forEach((swatch) => {
          const isActive = swatch.dataset.variantId === variantId
          swatch.classList.toggle('color-swatch--selected', isActive)
          swatch.setAttribute('aria-pressed', String(isActive))
        })
      }

      variantSwatches.forEach((swatch) => {
        swatch.addEventListener('click', () => {
          setActiveVariant(swatch.dataset.variantId)
        })
      })

      const defaultVariantId = container.dataset.selectedVariantId
        || variantSwatches[0]?.dataset.variantId
        || variantImages[0]?.dataset.variantId

      if (defaultVariantId) {
        setActiveVariant(defaultVariantId)
      }
    })
  }

  function initSocialFeedsModal(root = document) {
    root.querySelectorAll('.social-feeds-section').forEach((section) => {
      if (section.dataset.socialFeedsModalInit === 'true') return

      const modal = section.querySelector('[data-social-feeds-modal]')
      const drawer = modal?.querySelector('.social-feeds-modal__drawer')
      const drawerWrapper = modal?.querySelector('.drawer-wrapper')
      const closeTriggers = modal?.querySelectorAll('[data-social-feeds-modal-close]')
      const openerSlides = section.querySelectorAll('.social-feeds-main-swiper .swiper-slide')
      const modalSwiperEl = modal?.querySelector('.social-feeds-modal-swiper')
      const mainSwiperEl = section.querySelector('.social-feeds-main-swiper')
      const shouldLoopModal = mainSwiperEl?.dataset.loop === 'true'

      if (!modal || !drawer || !modalSwiperEl || !openerSlides.length) return

      const modalSwiper = new Swiper(modalSwiperEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: shouldLoopModal,
        navigation: {
          nextEl: modal.querySelector('[data-social-feeds-next]'),
          prevEl: modal.querySelector('[data-social-feeds-prev]'),
        },
      })

      const stopModalVideos = () => {
        modal.querySelectorAll('video').forEach((video) => {
          video.pause()
        })
      }

      const queuePlayActiveModalVideo = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            playActiveModalVideo()
          })
        })
      }

      const playActiveModalVideo = () => {
        const activeSlide = modal.querySelector('.swiper-slide-active')
        const activeVideo = activeSlide?.querySelector('video')
        if (activeVideo) {
          activeVideo.currentTime = 0
          activeVideo.play().catch(() => { })
        }
      }

      const hideStickyHeader = () => {
        const stickyHeader = document.querySelector('.section-header')
        if (!stickyHeader) return

        stickyHeader.dataset.socialFeedsPrevHidden = stickyHeader.classList.contains('shopify-section-header-hidden') ? 'true' : 'false'

        document.querySelectorAll('.menu-drawer-container[open]').forEach((drawerContainer) => {
          drawerContainer.removeAttribute('open')
          const summary = drawerContainer.querySelector('summary')
          if (summary) {
            summary.setAttribute('aria-expanded', 'false')
          }
        })

        document.querySelectorAll('header-menu details[open]').forEach((detail) => {
          detail.removeAttribute('open')
          const summary = detail.querySelector('summary')
          if (summary) {
            summary.setAttribute('aria-expanded', 'false')
          }
        })

        document.querySelectorAll('details-modal details[open]').forEach((detail) => {
          detail.removeAttribute('open')
          const summary = detail.querySelector('summary')
          if (summary) {
            summary.setAttribute('aria-expanded', 'false')
          }
        })

        stickyHeader.classList.add('shopify-section-header-hidden')
        stickyHeader.dataset.hiddenBySocialFeedsModal = 'true'
      }

      const restoreStickyHeader = () => {
        const stickyHeader = document.querySelector('.section-header')
        if (!stickyHeader) return
        if (stickyHeader.dataset.hiddenBySocialFeedsModal !== 'true') return

        const wasHiddenBeforeModal = stickyHeader.dataset.socialFeedsPrevHidden === 'true'
        if (!wasHiddenBeforeModal) {
          stickyHeader.classList.remove('shopify-section-header-hidden')
        }

        delete stickyHeader.dataset.socialFeedsPrevHidden
        delete stickyHeader.dataset.hiddenBySocialFeedsModal
      }

      const openModal = (index) => {
        hideStickyHeader()
        modal.classList.add('is-open')
        document.body.classList.add('social-feeds-modal-open')
        if (shouldLoopModal) {
          modalSwiper.slideToLoop(index, 0)
        } else {
          modalSwiper.slideTo(index, 0)
        }
        stopModalVideos()
        queuePlayActiveModalVideo()
      }

      const closeModal = () => {
        modal.classList.remove('is-open')
        document.body.classList.remove('social-feeds-modal-open')
        stopModalVideos()
        restoreStickyHeader()
      }

      openerSlides.forEach((slide, index) => {
        slide.addEventListener('click', () => {
          const mappedIndex = Number(slide.dataset.socialSlideIndex)
          openModal(Number.isNaN(mappedIndex) ? index : mappedIndex)
        })
      })

      closeTriggers.forEach((trigger) => {
        trigger.addEventListener('click', closeModal)
      })

      drawerWrapper?.addEventListener('click', (event) => {
        if (!modal.classList.contains('is-open')) return
        if (event.target.closest('.social-feeds-modal__drawer')) return
        closeModal()
      })

      modalSwiper.on('slideChange', () => {
        stopModalVideos()
        queuePlayActiveModalVideo()
      })

      const handleEscapeKeydown = (event) => {
        if (event.key === 'Escape' && modal.classList.contains('is-open')) {
          closeModal()
        }
      }

      document.addEventListener('keydown', handleEscapeKeydown)
      registerSectionCleanup(section, () => {
        document.removeEventListener('keydown', handleEscapeKeydown)
        modalSwiper.destroy(true, true)
      })

      section.dataset.socialFeedsModalInit = 'true'
    })
  }

  function initProductDescriptionToggle(root = document) {
    root.querySelectorAll('.product__description').forEach((section) => {
      if (section.dataset.descriptionToggleInit === 'true') return
      section.dataset.descriptionToggleInit = 'true'

      const content = section.querySelector('.description')
      const toggle = section.querySelector('.product__description-toggle')
      if (!content || !toggle) return

      const labelMore = toggle.dataset.labelMore || 'Read more'
      const labelLess = toggle.dataset.labelLess || 'Show less'

      toggle.type = 'button'

      const setExpandedState = (isExpanded) => {
        section.classList.toggle('is-expanded', isExpanded)
        toggle.textContent = isExpanded ? labelLess : labelMore
        toggle.setAttribute('aria-expanded', String(isExpanded))
      }

      const syncOverflow = () => {
        const hasOverflow = content.scrollHeight > content.clientHeight + 1
        section.classList.toggle('has-overflow', hasOverflow)

        if (!hasOverflow) {
          setExpandedState(true)
        }
      }

      setExpandedState(false)
      syncOverflow()

      toggle.addEventListener('click', () => {
        const willExpand = !section.classList.contains('is-expanded')
        setExpandedState(willExpand)

        if (!willExpand) {
          content.scrollIntoView({ block: 'nearest', behavior: 'smooth' })
        }
      })

      window.addEventListener('resize', syncOverflow)
      registerSectionCleanup(section, () => {
        window.removeEventListener('resize', syncOverflow)
      })
    })
  }

  function initComparisonTableToggle(root = document) {
    root.querySelectorAll('[data-comparison-table]').forEach((section) => {
      if (section.dataset.comparisonTableToggleInit === 'true') return
      section.dataset.comparisonTableToggleInit = 'true'

      const hiddenRows = Array.from(section.querySelectorAll('[data-comparison-hidden-row]'))
      const toggle = section.querySelector('[data-comparison-toggle]')
      if (!hiddenRows.length || !toggle) return

      const labelMore = toggle.dataset.labelMore || 'Show more'
      const labelLess = toggle.dataset.labelLess || 'Show less'

      toggle.type = 'button'

      const setExpandedState = (isExpanded) => {
        section.classList.toggle('is-expanded', isExpanded)
        hiddenRows.forEach((row) => {
          row.hidden = !isExpanded
        })
        toggle.textContent = isExpanded ? labelLess : labelMore
        toggle.setAttribute('aria-expanded', String(isExpanded))
      }

      setExpandedState(false)

      toggle.addEventListener('click', () => {
        const willExpand = !section.classList.contains('is-expanded')
        setExpandedState(willExpand)

        if (!willExpand) {
          section.scrollIntoView({ block: 'nearest', behavior: 'smooth' })
        }
      })
    })
  }

  // 暫停與播放功能
  function toggleAutoplay(el, swiper) {
    if (!swiper.autoplay) return
    const controlBtn = el.querySelector('.control')
    const isPaused = el.classList.contains('is-paused')
    if (isPaused) {
      swiper.autoplay.start()
      el.classList.remove('is-paused')
      if (controlBtn) controlBtn.innerHTML = PAUSE_ICON
    } else {
      swiper.autoplay.stop()
      el.classList.add('is-paused')
      if (controlBtn) controlBtn.innerHTML = PLAY_ICON
    }
  }

  // motion.js
  function initMotionAnimations(root = document) {
    if (typeof animate !== 'function' || typeof inView !== 'function') {
      console.warn('Motion animate/inView is not available')
      return
    }

    forEachInScope(root, '.motion', (el, motionIndex) => {
      if (el.dataset.motionInit === 'true') return
      el.dataset.motionInit = 'true'

      let stopInView = null
      stopInView = inView(
        el,
        (element) => {
          if (element.dataset.motionAnimated === 'true') return
          element.dataset.motionAnimated = 'true'

          const shouldSkipTranslate = element.dataset.motionNoTransform === 'true'

          animate(
            element,
            shouldSkipTranslate
              ? { opacity: [0, 1] }
              : { opacity: 1, y: [40, 0] },
            {
              duration: 0.6,
              easing: [0.17, 0.55, 0.55, 1],
            }
          )

          if (typeof stopInView === 'function') {
            stopInView()
          }
        },
        { margin: '0px 0px 0px 0px' }
      )

      registerSectionCleanup(el.closest('.motion'), () => {
        el.dataset.motionInit = 'false'
        el.dataset.motionAnimated = 'false'
        if (typeof stopInView === 'function') {
          stopInView()
        }
      })
    })
  }

  // Anchor 按鈕平滑捲動
  document.addEventListener('click', (e) => {
    const anchorLink = e.target.closest('.custom-buttons.anchor > a[href^="#"]')
    if (!anchorLink) return

    const targetId = anchorLink.getAttribute('href').slice(1)
    if (!targetId) return

    const targetEl = document.getElementById(targetId)
    if (!targetEl) return

    e.preventDefault()
    targetEl.scrollIntoView({ behavior: 'smooth' })
  })

  // 全站初始
  document.addEventListener('DOMContentLoaded', () => {
    initSwiperSlideshow()
    initSwiperAutoplayProgressSync()
    initProductComparisonCards()
    initSocialFeedsModal()
    initProductDescriptionToggle()
    initComparisonTableToggle()
    initMotionAnimations()
  })

  // Shopify section reload
  document.addEventListener('shopify:section:load', (e) => {
    initSwiperSlideshow(e.target)
    initSwiperAutoplayProgressSync(e.target)
    initProductComparisonCards(e.target)
    initSocialFeedsModal(e.target)
    initProductDescriptionToggle(e.target)
    initComparisonTableToggle(e.target)
    initMotionAnimations(e.target)
  })

  document.addEventListener('shopify:section:unload', (e) => {
    e.target.querySelectorAll('.custom-swiper').forEach((el) => {
      if (el.swiper) {
        el.swiper.destroy(true, true)
      }
    })

    forEachInScope(e.target, '.social-feeds-section', (section) => {
      runSectionCleanup(section)
      section.dataset.socialFeedsModalInit = 'false'
    })

    forEachInScope(e.target, '.product__description', (section) => {
      runSectionCleanup(section)
      section.dataset.descriptionToggleInit = 'false'
    })

    forEachInScope(e.target, '[data-comparison-table]', (section) => {
      runSectionCleanup(section)
      section.dataset.comparisonTableToggleInit = 'false'
    })
  })

  // 暴露給其他地方用
  window.createCustomSwiper = createCustomSwiper
  window.initSwiperSlideshow = initSwiperSlideshow
  window.initSwiperAutoplayProgressSync = initSwiperAutoplayProgressSync
  window.initProductComparisonCards = initProductComparisonCards
  window.initProductDescriptionToggle = initProductDescriptionToggle
  window.initComparisonTableToggle = initComparisonTableToggle
  window.initMotionAnimations = initMotionAnimations
})()
